import React from 'react';
import { Home, Users, Star, Settings, Bell, LogOut } from 'lucide-react';

const TopNav = ({ currentView, setView }) => {
    return (
        <div className="dashboard-top-nav">
            <div className="nav-pills">
                <button 
                    className={`nav-pill ${currentView === 'day' ? 'active' : ''}`}
                    onClick={() => setView('day')}
                >
                    <Home size={18} /> Home
                </button>
                <button 
                    className={`nav-pill ${currentView === 'month' ? 'active' : ''}`}
                    onClick={() => setView('month')}
                >
                    <Users size={18} /> Organization
                </button>
                <button className="nav-pill">
                    <Star size={18} /> Favorite
                </button>
                <button className="nav-pill">
                    <Settings size={18} /> Setting
                </button>
            </div>
            
            <div className="nav-profile">
                <div className="bell-icon">
                    <Bell size={20} fill="currentColor" />
                </div>
                <div className="profile-chip">
                    <img 
                        src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&q=80" 
                        alt="Carlo dem" 
                        className="profile-avatar"
                    />
                    <div className="profile-info">
                        <span className="profile-name">Carlo dem</span>
                        <span className="profile-role">Event Manager</span>
                    </div>
                </div>
                <div className="logout-icon">
                    <LogOut size={20} />
                </div>
            </div>
        </div>
    );
};

export default TopNav;
